// Track operator ID from URL parameter (?op=7)
// Saves to localStorage and attaches to all registrations

export const initOperatorTracking = () => {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const op = params.get("op");
  if (op && /^\d{1,2}$/.test(op)) {
    localStorage.setItem("agentsvp_operator_id", op);
    localStorage.setItem("agentsvp_operator_ts", Date.now().toString());
  }
};

export const getTrackedOperatorId = () => {
  if (typeof window === "undefined") return "";
  const op = localStorage.getItem("agentsvp_operator_id");
  const ts = localStorage.getItem("agentsvp_operator_ts");
  if (!op) return "";
  // Expire after 30 days
  if (ts && Date.now() - parseInt(ts) > 30 * 24 * 60 * 60 * 1000) {
    localStorage.removeItem("agentsvp_operator_id");
    localStorage.removeItem("agentsvp_operator_ts");
    return "";
  }
  return op;
};
